import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ClockIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="#001A19"
    title={t`Clock`}
    {...props}
  >
    <Path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm.75-9a.75.75 0 0 0-1.5 0v3.5a.75.75 0 0 0 .3.6l2 1.5a.75.75 0 1 0 .9-1.2l-1.7-1.275V5Z"
      clipRule="evenodd"
    />
  </Icon>
);
